// Web Analytics Composable
// Handles initialization of Incentit Web Analytics tracking

import { watch } from 'vue'
import { useAuthStore } from '@/stores/auth'

declare global {
  interface Window {
    WebAnalyticsConfig?: {
      siteName: string
      userName?: string
    }
  }
}

export function useWebAnalytics() {
  const authStore = useAuthStore()

  /**
   * Initialize web analytics with site name and user email
   */
  function initializeAnalytics() {
    // Set up the configuration
    window.WebAnalyticsConfig = {
      siteName: 'Incentit IQ',
      userName: authStore.currentUser?.uniqueIdentifier || 'anonymous'
    }

    // Load the analytics widget script if not already loaded
    if (!document.querySelector('script[src="https://owl.incentit.com/widget.js"]')) {
      const script = document.createElement('script')
      script.src = 'https://owl.incentit.com/widget.js'
      script.async = true
      document.body.appendChild(script)
    }
  }

  /**
   * Update analytics user when authentication changes
   */
  function setupAnalyticsWatcher() {
    // Watch for authentication changes
    watch(
      () => authStore.currentUser,
      (newUser) => {
        if (newUser && window.WebAnalyticsConfig) {
          // Update the user name when user logs in
          window.WebAnalyticsConfig.userName = newUser.uniqueIdentifier || 'anonymous'
        }
      },
      { immediate: true }
    )
  }

  return {
    initializeAnalytics,
    setupAnalyticsWatcher
  }
}
